import './VideoPage.css';
import './PDFPage.css';
import i1c01 from '../assets/images/pdf_converted/1c-01.png';
import i1c02 from '../assets/images/pdf_converted/1c-02.png';
import i1c03 from '../assets/images/pdf_converted/1c-03.png';
import i1c04 from '../assets/images/pdf_converted/1c-04.png';
import i1c05 from '../assets/images/pdf_converted/1c-05.png';
import i1c06 from '../assets/images/pdf_converted/1c-06.png';
import i1c07 from '../assets/images/pdf_converted/1c-07.png';
import i1c08 from '../assets/images/pdf_converted/1c-08.png';
import i1c09 from '../assets/images/pdf_converted/1c-09.png';
import i1c10 from '../assets/images/pdf_converted/1c-10.png';
import i1c11 from '../assets/images/pdf_converted/1c-11.png';
import i1c12 from '../assets/images/pdf_converted/1c-12.png';
import i1c13 from '../assets/images/pdf_converted/1c-13.png';
import i1c14 from '../assets/images/pdf_converted/1c-14.png';
import i1c15 from '../assets/images/pdf_converted/1c-15.png';
import i1c16 from '../assets/images/pdf_converted/1c-16.png';
import i1c17 from '../assets/images/pdf_converted/1c-17.png';
import i1c18 from '../assets/images/pdf_converted/1c-18.png';
import i1c19 from '../assets/images/pdf_converted/1c-19.png';
import i1c20 from '../assets/images/pdf_converted/1c-20.png';
import i1c21 from '../assets/images/pdf_converted/1c-21.png';
import i1c22 from '../assets/images/pdf_converted/1c-22.png';
import i1c23 from '../assets/images/pdf_converted/1c-23.png';


const IndexVideoBPage = () => {

  return (
    <div className="container_12">
      <div className="grid_12">
        <div className="grid_12 alpha">
          <div className="box-3">
            <div className="gradient_1">
              <h2>邀请赛会序</h2>
            </div>
            <div
              className="box-3_pad_3 p_text_lineheight"
              style={{
                fontSize: "18px",
                textIndent: "Video0px",
              }}
            >
<img src={i1c01} alt="" />
<img src={i1c02} alt="" />
<img src={i1c03} alt="" />
<img src={i1c04} alt="" />
<img src={i1c05} alt="" />
<img src={i1c06} alt="" />
<img src={i1c07} alt="" />
<img src={i1c08} alt="" />
<img src={i1c09} alt="" />
<img src={i1c10} alt="" />
<img src={i1c11} alt="" />
<img src={i1c12} alt="" />
<img src={i1c13} alt="" />
<img src={i1c14} alt="" />
<img src={i1c15} alt="" />
<img src={i1c16} alt="" />
<img src={i1c17} alt="" />
<img src={i1c18} alt="" />
<img src={i1c19} alt="" />
<img src={i1c20} alt="" />
<img src={i1c21} alt="" />
<img src={i1c22} alt="" />
<img src={i1c23} alt="" />
            {/* <iframe
              src='/images/1c.pdf#toolbar=0&navpanes=0'
              width="100%"
              className="pdf1_h_xs pdf1_h_sm pdf1_h_md pdf1_h_lg pdf1_h_xl"
              title="PDF Viewer"
              frameBorder="0"
            >
              This browser does not support PDFs. Please download the PDF to view it: <a href='/images/pdf1.pdf'>Download PDF</a>
            </iframe> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default IndexVideoBPage;

